<template>
  <section id="map"></section>
</template>
<script>
import Map from 'ol/Map';
import XYZ from 'ol/source/XYZ';
import View from 'ol/View';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {defaults as defaultInteractions} from 'ol/interaction';
import { fromLonLat } from 'ol/proj';

import { Icon, Style } from 'ol/style';
import 'ol/ol.css'

export default {
  props: {
    zoom: {
      type: Number,
      default: 10,
    },
    lat: {
      type: Number,
      default: 0,
    },
    lng: {
      type: Number,
      default: 0,
    },
    marker: Boolean,
  },
  mounted() {
    this.mountMap();
  },
  updated() {
    this.mountMap();
  },
  methods: {
    createStyle(src,options = {}) {
      return new Style({
        image: new Icon({
          ...options,
          anchor: [0.5, 1],
          src,
        }),
      });
    },
    mountMap() {
      const coords = fromLonLat([this.lng, this.lat]);
      const iconFeature = new Feature(new Point(coords));
      iconFeature.set('style', this.createStyle(process.env.MARKER_PATH, { scale: 0.1 }));
      this.$map = new Map({
        target: 'map',
        interactions: defaultInteractions({
          onFocusOnly: true,
          mouseWheelZoom: false
        }),
        loadTilesWhileInteracting: true,
        layers: [
          new TileLayer({
            source: new XYZ({
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            }),
          }),
          this.marker &&
            new VectorLayer({
              style: f => f.get('style'),
              source: new VectorSource({ features: [iconFeature] }),
            }),
        ],
        view: new View({
          center: coords,
          zoom: this.zoom,
        }),
      });
    },
  },
};
</script>
<style scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue